import React from 'react'
import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

export default function AccordionHeading({ title, data }) {
  const { t } = useTranslation()

  const email = data && data.email && data.email.users_setting === 1 ? t('notification_settings.options.email') : null
  const push = data && data.push && data.push.users_setting === 1 ? t('notification_settings.options.push') : null
  const app = data && data.app && data.app.users_setting === 1 ? t('notification_settings.options.app') : null

  return (
    <div className={`${styles.accordionTitle}`}>
      <div className={`${styles.heading}`}>
        <h2>{title}</h2>
        <h4>
          {email && (
            <span>{`${email}${data.push.users_setting === 1 || data.app.users_setting === 1 ? ', ' : ''}`}</span>
          )}
          {push && <span>{`${push}${data.app.users_setting === 1 ? ', ' : ''}`}</span>}
          {app && <span>{`${app}`}</span>}
          {!email && !push && !app ? (
            <span className={styles.notificationsFlag}>{t('notification_settings.options.notifications')}</span>
          ) : (
            ''
          )}
        </h4>
      </div>
    </div>
  )
}
